module.exports = __webpack_public_path__ + "img/project.13ec9e13.png";